import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { ProductService } from '../../core/services/product.service';
import { TaxRateService } from '../../core/services/tax-rate.service';
import { StudioService } from '../../core/services/studio.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

const PRODUCT_TYPES = [
  { id: 0, name: 'その他' }, { id: 1, name: '月会費' }, { id: 2, name: '入会金・事務手数料' },
  { id: 3, name: 'ロッカー費' }, { id: 4, name: 'PT費' }, { id: 5, name: '物販' },
];

@Component({
    selector: 'app-product-new',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;新規作成</span>
        </div>
        <div class="card-body">
          <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
          <form novalidate name="productCreateForm" #productCreateForm="ngForm" (ngSubmit)="save(productCreateForm)">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-4">
                    <label class="col-form-label">商品種別</label>
                    <select class="form-control" [(ngModel)]="selectProductType" name="productType" required>
                      <option [ngValue]="null">選択してください</option>
                      @for (pt of productTypes; track pt.id) {
                        <option [ngValue]="pt">{{pt.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-8">
                    <label class="col-form-label">商品名</label>
                    <input type="text" class="form-control" [(ngModel)]="product.name" name="name" sfMaxLength="200">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-4">
                    <label class="col-form-label">金額</label>
                    <input type="number" class="form-control" [(ngModel)]="product.amount" name="amount" required>
                  </div>
                  <div class="col-md-4">
                    <label class="col-form-label">消費税率</label>
                    <select class="form-control" [(ngModel)]="selectTaxRate" name="taxRate" required>
                      <option [ngValue]="null">選択してください</option>
                      @for (tr of taxRates; track tr.id) {
                        <option [ngValue]="tr">{{(tr.rate * 100)}}%</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-8">
                    <label class="col-form-label">備考</label>
                    <input type="text" class="form-control" [(ngModel)]="product.note" name="note" sfMaxLength="200">
                  </div>
                </div>
                <div>
                  <div class="form-group row">
                    <div class="col-md-8 custom-control custom-radio">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_all_create0" class="custom-control-input" [(ngModel)]="isAllCreate" name="isAllCreate" value="0">
                        <label class="custom-control-label" for="is_all_create0">有効店を選択</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="is_all_create1" class="custom-control-input" [(ngModel)]="isAllCreate" name="isAllCreate" value="1">
                        <label class="custom-control-label" for="is_all_create1">全店舗有効</label>
                      </div>
                    </div>
                  </div>
                  @if (isAllCreate === '0') {
                    <div class="form-group col-md-6 border" style="max-height: 300px; overflow-y: auto;">
                      <table class="table table-sm">
                        @for (studio of studios; track studio.id; let i = $index) {
                          <tr>
                            <td class="border-0">
                              <label class="mb-0 w-100">
                                <div class="custom-control custom-checkbox custom-control-inline">
                                  <input class="custom-control-input" [(ngModel)]="studioCheck[studio.id]" [id]="'check_' + i" type="checkbox" [value]="studio.id" [name]="'check_' + i">
                                  <label class="custom-control-label" [for]="'check_' + i">{{studio.name}}</label>
                                </div>
                              </label>
                            </td>
                          </tr>
                        }
                      </table>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-right">
                <a routerLink="/product" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                <button type="submit" class="btn btn-success" [disabled]="saving || productCreateForm.invalid || isInvalid()"><i class="fa s-icon-save"></i>&nbsp;保存</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class ProductNewComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private productService = inject(ProductService);
  private taxRateService = inject(TaxRateService);
  private studioService = inject(StudioService);
  private router = inject(Router);
  private flash = inject(FlashService);

  product: any = {};
  studios: any[] = [];
  taxRates: any[] = [];
  studioCheck: { [id: number]: boolean } = {};
  isAllCreate = '1';
  selectProductType: any = null;
  selectTaxRate: any = null;
  saving = false;
  readonly productTypes = PRODUCT_TYPES;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('商品マスター', 's-icon-edit');
    const [studios, taxRates] = await Promise.all([
      this.studioService.list('all'),
      this.taxRateService.get(),
    ]);
    this.studios = studios ?? [];
    this.taxRates = taxRates ?? [];
  }

  isInvalid(): boolean {
    return !this.selectProductType || this.product.amount === null || this.product.amount === undefined || this.product.amount === '' ||
      !this.selectTaxRate || (this.isAllCreate === '0' && !Object.values(this.studioCheck).some(Boolean));
  }

  async save(form?: NgForm): Promise<void> {
    if (form?.invalid || this.isInvalid()) {
      form?.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const targetStudios = this.isAllCreate === '1'
        ? this.studios
        : this.studios.filter(s => this.studioCheck[s.id]);
      const json = targetStudios.map((studio: any) => ({
        name: this.product.name,
        amount: this.product.amount,
        note: this.product.note,
        productType: this.selectProductType?.id,
        taxRateId: this.selectTaxRate?.id,
        status: 1,
        studioId: studio.id,
      }));
      await this.productService.create(json);
      // 旧版 product.js:199-202: 作成後は一覧の先頭Flashで通知
      this.flash.create('success', '商品を新規作成しました');
      window.scrollTo(0, 0);
      this.router.navigate(['/product']);
    } finally {
      this.saving = false;
    }
  }
}
